/** WebSocket reconnection backoff settings. */
export const WS_RECONNECT_MAX_ATTEMPTS = 5;
export const WS_RECONNECT_BASE_DELAY_MS = 3000;
export const WS_RECONNECT_MAX_DELAY_MS = 30_000;

/** File upload timeout when no server response is received. */
export const FILE_UPLOAD_TIMEOUT_MS = 30_000;

/** Delay before clearing chat state after back navigation transition. */
export const CHAT_BACK_TRANSITION_MS = 300;

/** Adaptive polling intervals for active connection refresh. */
export const REFRESH_INTERVAL_ACTIVE_CHAT_MS = 2 * 60 * 1000;
export const REFRESH_INTERVAL_ACTIVE_USER_MS = 3 * 60 * 1000;
export const REFRESH_INTERVAL_INACTIVE_USER_MS = 10 * 60 * 1000;

/** User inactivity detection thresholds. */
export const USER_INACTIVITY_THRESHOLD_MS = 5 * 60 * 1000;
export const INACTIVITY_CHECK_INTERVAL_MS = 60_000;

/** Scroll position threshold to consider the chat scrolled to the bottom. */
export const SCROLL_BOTTOM_THRESHOLD_PX = 80;

/** Time formatting helpers. */
export const MINUTES_PER_HOUR = 60;
export const NOON_HOUR = 12;
